import { gql } from '@apollo/client'
import { AddressFragment } from '../fragments/address.fragments'

export const AddUpdateBestPracticeMutation = gql`
    mutation addUpdateBestPracticeMutation($input: BestPracticeInput!) {
        addUpdateBestPractice(input: $input) {
            id
            firmId
            isGlobal
            location {
                ...addressFragment
            }
            projectGroup
            parameters {
                selectedModifiers {
                    name
                }
                modifierList {
                    name
                }
            }
            parentProjectId
            projectElementNodeId
        }
    }
    ${AddressFragment}
`
export const RemoveBestPracticeMutation = gql`
    mutation removeBestPracticeMutation($input: BestPracticeInput!) {
        removeBestPractice(input: $input)
    }
`

export const IsBestPracticeOutOfSyncForUI = gql`
    mutation isBestPracticeOutOfSyncForUI($input: BestPracticeInput!) {
        isBestPracticeOutOfSyncForUI(input: $input) {
            action
            message
            latestVersionId
            currentVersionId
        }
    }
`
export const UpdateBestBestPracticeVersion = gql`
    mutation updateBestBestPracticeVersion($input: BestPracticeInput!) {
        updateBestBestPracticeVersion(input: $input) {
            id
            firmId
            isGlobal
            location {
                ...addressFragment
            }
            projectGroup
            parameters {
                selectedModifiers {
                    name
                }
                modifierList {
                    name
                }
            }
            parentProjectId
            projectElementNodeId
        }
    }
    ${AddressFragment}
`
